import { TableColumn } from "./default";

export const TableHeaderColumns: TableColumn[] = [
  { id: 1, name: "Local", key: "local" },
  { id: 2, name: "Id", key: "refId" },
  { id: 3, name: "Produto", key: "product" },
  {
    id: 4,
    name: "Agendado para",
    key: "dueDate",
  },
  {
    id: 5,
    name: "Quantidade",
    key: "quantidade",
  },
  { id: 6, name: "Status", key: "status" },
];
